let local = "Rintisa";

export default {
    general: {
        titleWindowsExplorer: 'RINTISA, Tienda virtual',
        iconWindowsExplorer: '',
        localStorageNamed: 'Rintisa',
        loaderImage: 'Cargando...', //require('./images/loader/831.gif'),
        loaderBackground: 'rgba(255,255,255,0.1)',
        loaderColor: 'text-info',
        business: 1,
        imagesPath: 'colusa',
        currency: 'S/ ',
    },

    icons: {
        menu: 'fas fa-bars fa-2x',
        user: 'fas fa-user',
        password: 'fa fa-unlock-alt',
        search: 'fas fa-search fa-2x',
        shoppingCart: 'fas fa-shopping-cart fa-7x',
        building: 'fa fa-building',
        phone: 'fa fa-phone',
        pin: 'fa fa-map-pin',
        road: 'fa fa-road',
        map: 'fa fa-map',
        city: 'fa fa-city',
        envelope: 'fa fa-envelope-open-text',
        globalAmericas: 'fa fa-globe-americas',
        shield: 'fa fa-shield',
        favorite: "fas fa-heart",
        trash: "fa fa-trash",
        backOrderTrue: 'fa fa-plus',
        backOrderFalse: 'fa fa-minus',
        arrowLeft: 'fas fa-caret-left',
        arrowRight: 'fas fa-caret-right',
        datasheet: 'far fa-file-pdf fa-2x',
        cfdi: 'fas fa-file-invoice-dollar',
        report: 'fas fa-file-pdf',
        xml: 'fas fa-file-alt',
        detail: 'fas fa-info-circle',
        select: "fas fa-check"
    },

    navBar: {
        icon: require('../../images/rintisa/navBarIcon.png'),
        backgroundColor: '#005da8',
        iconColor: 'white',
        textColor: 'white',
        menuCategoriesBackground: '#005da8',
        textColorCategorie: 'white',
        menuCategoriesBackgroundHover: '#dd0054',
        textColorCategorieHover: 'white',
        iconModal: 'white',
        iconBackground: 'rgb(0,93,158)',
    },

    dashboard: 'Carousel',
    slider: {
        videoLocation: '',
        videoFormat: '',
        videoText: '',
        image: '',
    },

    home: {
        images: require('../../images/cig/promo.png')
    },
    carousel: {
        images: [{ path: require('../../images/cig/carousel/banner1.jpg') },
        { path: require('../../images/cig/carousel/banner2.jpg') },
        { path: require('../../images/cig/carousel/banner3.jpg') }]
    },

    aboutUs: {
        active: true,
        description: `Nuestros más de 50 años de experiencia en el rubro nos han convertido en los líderes de la categoría, trayendo innovación y desarrollo, soportado en nuestro talento humano y tecnología de última generación.`,
        mission: 'Generar la transformación de la categoría, a través de nuestras marcas líderes, reconocidas con la mayor oferta de productos e innovaciones, que reflejan el amor que les tenemos buscando su disfrute y bienestar.',
        vision: 'Conducir el desarrollo de la categoría y continuar liderando cada segmento con la mejor propuesta de valor.',
        values: [
            { title: 'Comunicación' },
            { title: 'Respeto' },
            { title: 'Innovación' },
            { title: 'Organización y orden' },
            { title: 'Planificación' },
        ],
        images: require('../../images/rintisa/about/quienes_somos.jpg'),
    },

    contactUs: {
        active: true,
        locations: [
            {
                name: 'Miraflores',
                street: 'Av. José Pardo 434, Miraflores.',
                country: 'Perú, ZIP code 15074',
                phone: 'Teléfono: 3590044',
                email: 'consultas@ricocan.com',
                maps: 'https://www.google.com/maps/place/lit+one,+Av.+Jos%C3%A9+Pardo+434,+Miraflores+15074,+Per%C3%BA/@-12.1186961,-77.0352861,17z/data=!3m1!4b1!4m5!3m4!1s0x9105c817fc7ca003:0xcfaad67d9ba62a4!8m2!3d-12.1186961!4d-77.0330974',
            }
        ],
    },
    questions: {
        active: false,
    },
    claim: {
        active: false,
    },

    termPage: {
        active: false,
    },


    itemsList: {
        backgroundColor: 'rgba(255,255,255, 0.5)',
        textColor: 'rgba(0,0,0, 0.8)',
        iconColor: 'rgb(0,93,158)',
        textPrice: 'rgb(0,93,158)'
    },
    // Colors for BG and text in ShopingCartView
    shoppingList: {
        productList: '#efefef',
        textProductList: 'rbg (0,0,0)',
        summaryList: 'rgb(0,93,158)',
        textsummaryList: 'rbg(255,255,255)'
    },

    footer: {
        icon: require('../../images/rintisa/footerIcon.png'),
        power: require('../../images/powered_fmb_white.png'),
        backgroundColor: '#005da8',
        iconColor: 'rgb(255,255,255)',
        textColor: 'rgb(255,255,255)',

        info: {
            hoursIcon: 'fas fa-2x fa-user-clock',
            hours: 'Lunes a Viernes de 9:00 hrs. a 18:00 hrs',
            emailIcon: 'fas fa-2x fa-envelope',
            email: 'consultas@ricocan.com',
            phoneIcon: 'fas fa-2x fa-phone',
            phone: '(01) 359 00 44',
            addressIcon: 'fas fa-2x fa-location-arrow',
            address: 'Av. José Pardo 434, Miraflores.',
        },

        socialMedia: {
            youtubeIcon: 'fab fa-4x fa-youtube',
            youtube: 'https://www.youtube.com/channel/UCZUQonpUrLVJeOHAhQ2_4Kw/featured',
            visibilityYoutube: true,
            instagramIcon: 'fab fa-4x fa-instagram',
            instagram: 'https://www.instagram.com/ricocanoficial/',
            visibilityInstagram: true,
            facebookIcon: 'fab fa-4x fa-facebook-f',
            facebook: 'https://www.facebook.com/ricocanoficial/',
            visibilityFacebook: true,

        }
    },

    paymentMethod: {
        paypal: {
            enable: true,
            clienId: 'AcgfSWjvFifar4P_3alUSPkhf0Z5g21gs1ieaFCF0HoFojz5GnYxYFE5L-uIH4tZEqWffcTzN_jnqf6l',
            //clienId: 'Aa2jAA2wV-jR9wXcDcaBnAatmI5nbANCx0TaQks_UWDAEKWAkuRwEvCap3krt7my-8FciPFo73rbOCJH',
        },
        transbank: {
            enable: false,
        }
    },
    licence: new Date(2027, 0, 1, 0, 0, 0, 0),

    // LOCAL
    // BASE_URL: 'http://localhost:2052/api',
    // ASSETS: 'http://localhost:2052/api/uploads/',

    // PRUEBAS
    // BASE_URL: 'http://190.12.74.103:3050/api',
    // ASSETS: 'http://190.12.74.103:3050/api/uploads/',

    // PRODUCTIVA
    // BASE_URL: 'http://190.12.74.103:4050/api',
    // ASSETS: 'http://190.12.74.103:4050/api/uploads/',

    // PRODUCTIVA SSL
    BASE_URL: 'https://rintisa.shop:4050/api',
    ASSETS: 'https://rintisa.shop:4050/api/uploads/',

    //BASE_URL: 'http://172.20.51.15:3040/api',
    //ASSETS: 'http://172.20.51.15:3040/api/uploads/',

    //BASE_URL: 'http://190.12.74.99:3051/api', 
    //ASSETS: 'http://190.12.74.99:3051/api/uploads/', 

    localStorageNamed: local + 'E-commerce',
};
